<template>
  <div>
    <div class="main-body">
      <div class="content">
        <div class="list-item d-flex">
          <div class="img">
            <img :src="list.coverUrl" alt="" />
          </div>
          <div class="ml-5">
            <div class="d-flex">
              <div class="font-18 font-bold" style="color: #303133">{{ list.classesName }}</div>
            </div>
            <div class="d-flex mt-3" v-if="!isSign">
              <div class="f-els3_3 font-12" style="color: #84878d">上次学到：{{ list.lastScheduleName }}</div>
            </div>
            <div class="d-flex justify-between mt-4">
              <div v-show="!isSign || isShowZhibo">
                <a-button class="large-btn" shape="round" type="primary" v-if="!isSign && (list.lastStudy || 0)" @click="goToLivePlayerFn(list.lastScheduleId)">
                  继续学习
                </a-button>
                <a-button class="large-btn" shape="round" type="primary" v-if="!isSign && !(list.lastStudy || 0)" @click="goToLivePlayerFn(liveList[0].scheduleId)">
                  开始学习
                </a-button>
                <a-button class="large-btn ml-4" style="background: #fc665c" shape="round" type="primary" @click="goToLivePlayerFn(list.presentScheduleId)" v-if="list.presentScheduleId && !isSign">
                  <div class="d-flex">
                    正在直播
                    <img class="living-icon ml-1" :src="livingIcon" alt="" />
                  </div>
                </a-button>
              </div>
              <div v-show="isSign && !isShowZhibo">
                <a-button class="large-btn" shape="round" type="primary" @click="openSignFn">立即报名</a-button>
              </div>
            </div>
          </div>
          <!-- style="flex: 1" -->
          <div class="ml-4" style="margin-left: auto" v-if="!isSign">
            <div class="d-flex justify-center">
              <a-progress :width="120" :strokeWidth="8" strokeColor="#4B7DFD" :percent="list.studyProgress || 0" :success="{ percent: 30 }" type="circle">
                <template v-slot:format>
                  <div>
                    <p class="font-22 font-bold mb-1" style="color: #303133">{{ list.studyProgress || 0 }}%</p>
                    <span class="font-12" style="color: #84878d">学习进度</span>
                  </div>
                </template>
              </a-progress>
            </div>
            <!-- <div class="d-flex justify-center">
              <p>学习进度: {{ person }}%</p>
            </div>
            <div class="d-flex justify-center">
              <p>学习时长: {{ list.progress && list.progress.validWatchDuration && Model_data_click(list.progress.validWatchDuration) }}</p>
            </div> -->
          </div>
        </div>
      </div>
      <div class="px-4">
        <a-tabs v-model="tab" @change="changeTab" :tabBarStyle="{ color: '#84878D', height: '62px', 'font-weight': 600, marginBottom: '0' }">
          <!-- <a-tab-pane tab="课程目录" key="1" v-if="!isSign&&!isShowZhibo&&classCatalog && classCatalog.length">
            <div class="classCatalog" v-if="classCatalog && classCatalog.length">
              <div :key="item.chapterId" v-for="(item, index) in classCatalog">
                <div class="header d-flex justify-between mt-4">
                  <div>
                    <span class="font-16 color-181D21">{{ item.chapterName }}</span>
                  </div>
                  <div class="d-flex">
                    <div class="color-5E668D">作业完成 {{ item.doneExamNum }} / {{ item.examNum }}</div>
                    <img class="icon-img ml-1" :src="up" @click="showContent(item, index)" v-if="!item.isUp" alt="" />
                    <img class="icon-img ml-1" :src="downl" @click="showContent(item, index)" v-else alt="" />
                  </div>
                </div>
                <div v-if="item.isUp">
                  <div class="content" v-for="(i, idx) in item.knowList" :key="i.chapterId + '-' + idx">
                    <div class="d-flex mr-2" style="width: 50%;color:#181D21;font-size:16px;">
                      <img class="icon-img mr-1" :src="yb" alt="" />
                      {{ i.knowName }}
                    </div>
                    <div class="d-flex justify-between">
                      <div class="d-flex">
                        <div class="d-flex mr-2" style="width: 50px">
                          <div class="ml-10">
                            <div style="width: 60px;">
                              <img class="icon-img mr-1" :src="none" alt="" v-if="!i.resources || !i.resources.length" />
                              <img class="icon-img mr-1" :src="all" alt="" v-if="i.resources&&i.resources.length" />
                              <span>资料</span>
                            </div>
                            <div style="width: 60px;">
                              <img class="icon-img mr-1" :src="none" alt="" v-if="!i.exams || !i.exams.length" />
                              <img class="icon-img mr-1" :src="all" alt="" v-if="i.exams&&i.exams.length" />
                              <span>作业</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="d-flex align-end mt-3" v-if="i.resources&&i.resources.length">
                          <div class="link-name d-flex mr-2 cp" @click="getResource(i.resources)">
                            课件资料
                            <img class="icon-img ml-1" :src="down" alt="" />
                          </div>
                        </div>
                        <div class="d-flex align-end mt-3" v-if="i.exams && i.exams.length">
                          <div class="link-name mr-2 d-flex mr-2" @click="goToHomeWork(i)" v-for="k in i.exams" :key="k.id">
                            {{ k.examName }}
                            <img class="icon-img mr-1" :src="inTo" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="empty-content">
              <div class="d-flex justify-center mt-10">
                <img class="empty-img" :src="empty" alt="" />
              </div>
              <div class="text-center mt-4">没有找到相关课程</div>
            </div>
          </a-tab-pane> -->
          <a-tab-pane tab="课程目录" key="2">
            <a-list :grid="{ gutter: 16, column: 1 }">
              <a-list-item v-for="item in liveList" :key="item.scheduleId">
                <div class="list-content py-3">
                  <div class="list-item-zb d-flex justify-between">
                    <div>
                      <div class="d-flex" style="margin-bottom: 8px">
                        <div class="font-12 text-color mr-2 p-4" v-if="!isSign && item.lastStudy" style="background: #4b7dfd; color: #fff; border-radius: 3px; padding: 0 4px">
                          上次学到
                        </div>
                        <div class="font-16 font-bold f-els3_3">{{ item.scheduleName }}</div>
                      </div>
                      <div class="d-flex text-con-color" style="color: #84878d">
                        <div class="font-12 mr-4" v-if="item.studentShowTime">{{ getString(item.startTime, 5, 16) }}</div>
                        <div class="font-12 text-time-color" v-if="!isSign && item.status !== '0'">
                          已学{{ item.videoPercent ? item.videoPercent : '0' }}%
                        </div>
                      </div>
                    </div>
                    <div class="ml-4 d-flex">
                      <div class="d-flex">
                        <div @click="showEva(item)" class="cp">
                          <svg-icon style="font-size: 15px; margin-right: 7px; color: #000" :iconClass="!item.hasComment ? 'appraisal' : 'starActive'"></svg-icon>
                          <span class="font-12 text-gray" v-if="!isSign">{{
                            !item.hasComment ? '评价' : '已评价'
                          }}</span>
                        </div>
                        <div @click="showResource(item)" class="cp ml-4">
                          <svg-icon style="font-size: 15px; margin-right: 7px" iconClass="resource"></svg-icon>
                          <span class="font-12 text-gray" v-if="!isSign">资料</span>
                        </div>
                        <!-- <div @click="addVisible = true" class="pc" v-if="!isSign&&item.status !== '0'">
                          <img class="icon-img ml-4" :src="ask" alt="" />
                          <span class="ml-1" v-if="!isSign">课程问答</span>
                        </div> -->
                        <a-button shape="round" type="danger" class="ml-4" v-if="item.status == '1'" @click="isShowLive(item.scheduleId)" style="background: #fc665c">
                          <div class="d-flex">
                            正在直播
                            <img class="living-icon ml-1" :src="livingIcon" alt="" />
                          </div>
                        </a-button>
                        <a-button shape="round" type="primary" class="ml-4" v-if="item.status == '2' && !isSign" @click="goToLivePlayerFn(item.scheduleId)">
                          看回放
                        </a-button>
                        <a-button shape="round" type="primary" class="ml-4" v-if="item.status == '2' && isSign" @click="showToast">
                          观看回放
                        </a-button>
                        <a-button shape="round" class="ml-4" v-if="item.status == '0'" @click="showNoToast" style="background: #d6d7d8">
                          未开始
                        </a-button>
                      </div>
                    </div>
                  </div>
                </div>
              </a-list-item>
            </a-list>
          </a-tab-pane>
          <a-tab-pane tab="课程讨论" key="3" v-if="!isSign && !isShowZhibo">
            <div class="pb-6">
              <post ref="postRef" :classesId="classesId" :planclassesId="planclassesId"></post>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <drawer :title="title" :visible="visible" @handleOk="visible = false" @handleCancel="visible = false">
        <a-list :grid="{ gutter: 16, column: 1 }">
          <a-list-item style="margin-bottom: 0" v-for="(item, index) in ziLiaoList" :key="index">
            <div class="list-content" style="border-bottom: 1px solid #ced3dc">
              <div class="list-item-zb mb-3 d-flex justify-between">
                <div>
                  <div class="d-flex">
                    <div class="font-12 text-color mr-4" style="border: 0.5px solid; border-radius: 3px; color: #1564ff; width: 29px">
                      {{ item.resourceType == '9' ? '附件' : '课件' }}
                    </div>
                    <div class="font-17 font-bold" style="width: 300px">{{ item.resourceName }}</div>
                    <div class="ml-2" style="color: #1564ff; font-size: 16px; width: 32px" @click="getResourceList(item)">
                      {{ item.resourceType == '9' ? '下载' : '查看' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-list-item>
        </a-list>
      </drawer>
      <!-- <ZModel :width="434" :border="false" buttonText="评价" title="课程评价" :visible="isEvaluate" @close="evaClose(false)" @submit="submit">
        <div class="px-2">
          <a-form-model ref="activationForm" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 19, offset: 1 }">
            <a-form-model-item :label="item.title" prop="code" v-for="(item, num) in startList" :key="num">
              <div>
                <rate :ref="'rateRef' + scheduleId" @start="start" :start="item" />
              </div>
            </a-form-model-item>
            <a-form-model-item label="评价">
              <a-textarea v-model="content" placeholder="请输入评价" :rows="8" />
            </a-form-model-item>
          </a-form-model>
        </div>
      </ZModel> -->
      <add-modal :visible.sync="addVisible" @refresh="refresh"></add-modal>
      <evaluate-modal :visible.sync="isShowEva" @refresh="getInfo" :scheduleId="scheduleId"></evaluate-modal>
      <resourceList :resourceList="resourceList" ref="resourceList"></resourceList>
    </div>
  </div>
</template>
<script>
import {
  getMyClassDetail,
  openDetail,
  subjectTree,
  schedule,
  resource,
  // stars,
  addStart,
  openSign,
  openList,
} from '@/api/myClass'
// import { message } from 'ant-design-vue'
import { goToLivePlayer } from '@/utils/livePlay'
import livingIcon from '@/assets/icons/living.gif'
import Drawer from '@/components/Drawer/Index.vue'
import imagePreview from '../../components/imagePreview.vue'
import resourceList from './components/resourceList.vue'
import ZModel from '@/components/ZModal/index'
import rate from '@/components/rate'
import post from './components/qa.vue'
import addModal from './components/addModal'
import evaluateModal from '@/components/evaluateModal/evaluateModal'
import Vue from 'vue'
import down from '@/assets/icons/下载@2x.png'
import inTo from '@/assets/icons/进入 蓝@2x.png'
import eva from '@/assets/icons/评价 蓝@3x.png'
import ask from '@/assets/icons/问答 蓝@3x.png'
import yb from '@/assets/icons/一半@3x.png'
import good from '@/assets/icons/点赞@2x.png'
import comment from '@/assets/icons/评论@2x.png'
import read from '@/assets/icons/阅读@2x.png'
import none from '@/assets/icons/空@3x.png'
import all from '@/assets/icons/全部@3x.png'
import empty from '@/assets/empty.png'
import up from '@/assets/icons/上@3x.png'
import downl from '@/assets/icons/下@3x.png'
export default {
  name: 'MyClassDetail',
  components: {
    Drawer,
    imagePreview,
    ZModel,
    rate,
    addStart,
    post,
    addModal,
    evaluateModal,
    resourceList,
  },
  data() {
    return {
      isUp: false,
      tab: '2',
      content: '',
      startValue: 2,
      addVisible: false,
      isEvaluate: false,
      isShowImg: false,
      title: '课件资料',
      visible: false,
      value: '',
      eva,
      ask,
      yb,
      down,
      inTo,
      good,
      comment,
      read,
      none,
      all,
      empty,
      up,
      downl,
      livingIcon,
      classCatalog: [],
      liveList: [
        // {
        //   endTime: '',
        //   hasComment: false,
        //   pushType: '',
        //   scene: 'alone',
        //   scheduleId: 'fe654149c242b64c4ce1886702aa1171',
        //   scheduleName: '初中化学考前集训第1课 化学专业知识（一）',
        //   startTime: '2019-10-12 19:00:00',
        //   status: '2',
        //   videoDuration: 7200,
        //   watchDuration: null
        // }
      ], // 直播列表
      ziLiaoList: [],
      imageList: [], // 查看图片资料
      data: [
        {
          title: 'Title 1',
        },
        {
          title: 'Title 2',
        },
        {
          title: 'Title 3',
        },
        {
          title: 'Title 4',
        },
        {
          title: 'Title 5',
        },
        {
          title: 'Title 6',
        },
      ],
      list: {
        progress: {
          validWatchDuration: null,
        },
      },
      rules: {},
      startList: [],
      starts: [],
      scheduleId: '', // 课次id
      classesId: '',
      planclassesId: '',
      param: {},
      // isSign: false, //
      isSign: false,
      isShowZhibo: false,
      isShowEva: false,
      resourceList: [],
    }
  },
  created() {
    console.log(this.$route)
    if (this.$route.query.planclassesId && this.$route.query.classesId && this.$route.query.type) {
      this.planclassesId = this.$route.query.planclassesId
      this.classesId = this.$route.query.classesId
      this.tab = '2'
    }
    if (this.$route.query.noCourse) {
      this.isSign = true
      this.classesId = this.$route.query.classesId
      this.tab = '2'
    }
    if (this.$route.query.isSign) {
      this.isSign = false
      this.isShowZhibo = true
      this.classesId = this.$route.query.classesId
      this.tab = '2'
    }
    this.param = {
      classesId: this.classesId ? this.classesId : '',
    }
    this.planclassesId && (this.param.planclassesId = this.planclassesId)
    this.getInfo()
  },
  computed: {
    getString() {
      return function (time, star, end) {
        if (!time) {
          return ''
        }
        return time.slice(star, end)
      }
    },
    // person() {
    //   if (this.list.progress && this.list.progress.validWatchDuration && this.list.progress.scheduleVideoDuration) {
    //     return parseFloat(
    //       (
    //         ((this.list.progress.validWatchDuration * 100000) / (this.list.progress.scheduleVideoDuration * 100000)) *
    //         100
    //       ).toFixed(2)
    //     )
    //   } else {
    //     return 0
    //   }
    // },
  },
  watch: {
    // 侦听评价弹窗关闭，清空评价内容和评价星级
    isEvaluate(val) {
      if (val === false) {
        this.content = ''
        // this.starts = []
      }
    },
  },
  methods: {
    isShowLive(scheduleId) {
      if (this.isSign && !this.isShowZhibo) {
        this.$message.error('请先报名参加课程')
        return
      }
      goToLivePlayer(scheduleId, this.planclassesId)
    },
    showNoToast() {
      if (this.isSign && !this.isShowZhibo) {
        this.$message.error('请先报名参加课程')
        return
      }
      this.$message.error('直播尚未开始')
    },
    showToast() {
      this.$message.error('请先报名参加课程')
    },
    refresh() {
      // console.log(this.$refs.postRef)
      this.$refs.postRef && this.$refs.postRef.featchFun()
    },
    openSignFn() {
      const param = {
        classesId: this.classesId,
      }
      openSign(param).then((res) => {
        console.log(param)
        this.$nextTick(() => {
          this.isSign = false
          this.isShowZhibo = true
        })
        this.$message.success('报名成功')
        this.$store.commit('UPDATA_USER_INFO', {
          isAudition: '0',
        })
        this.$router.push({ name: 'course', params: { refresh: true } })
      })
    },
    showContent(item, index) {
      item.isUp = !item.isUp
      console.log(item.isUp)
      this.$forceUpdate()
    },
    setPerson(a, b) {
      if (a && b) {
        // console.log(a, b)
        return (((a * 100) / (b * 100)) * 100).toFixed(2) >= 100 ? '100' : (((a * 100) / (b * 100)) * 100).toFixed(2)
      } else {
        return 0
      }
    },
    goToLivePlayerFn(scheduleId) {
      goToLivePlayer(scheduleId, this.planclassesId)
    },
    toLivePlay(item) {
      // console.log(item)
      if (item.liveScheduleList && item.liveScheduleList.length) {
        const id = item.liveScheduleList[0].id
        goToLivePlayer(id, item.planclassesId)
      }
    },
    evaClose(isClose) {
      this.isShowEva = false
      this.isEvaluate = isClose
    },
    downloadExcel(url) {
      window.location.href = url
    },
    Model_data_click(num) {
      // console.log(num)
      return (num / 3600).toFixed(2)
    },
    async getInfo() {
      if (this.isSign || this.isShowZhibo) {
        const param = {
          classesId: this.classesId,
        }
        await openDetail(param).then((res) => {
          console.log(res)
          this.list = res
        })
        await openList(param).then((res) => {
          this.liveList = JSON.parse(JSON.stringify(res))
        })
      } else {
        getMyClassDetail(this.param).then((res) => {
          this.list = res
        })
        subjectTree(this.param).then((res) => {
          this.classCatalog = res.chapterList
          // console.log('res', res)
          this.classCatalog &&
            this.classCatalog.forEach((element) => {
              element.isUp = true
            })
        })
        schedule(this.param).then((res) => {
          this.liveList = res
        })
      }
    },
    getResource(data) {
      this.visible = true
      this.ziLiaoList = data
    },
    // 查看
    getResourceList(item) {
      resource({ id: item.id }).then((res) => {
        console.log(res)
        if (item.resourceType === '9') {
          this.downloadExcel(res.urls[0])
        } else {
          this.imageList = res.urls
          this.isShowImg = true
        }
        const routeData = this.$router.resolve({
          name: 'images',
          query: { imageList: this.imageList },
        })
        window.open(routeData.href, '_blank')
      })
    },
    goToHomeWork(i) {
      console.log('i', i)
      const { exams } = i
      this.$router.push({
        name: 'homeWork',
        // query: {
        //   classesId: 'ac9ff251d50bc86b3aa8a5997001c38f',
        //   examId: '9a14975e206e72b03a2bb78449f8b621',
        //   planclassesId: '30b6cab862e36e3b8de5f092d230fb15'
        // },
        params: {
          ...exams[0],
          classesId: this.classesId,
          planclassesId: this.planclassesId,
          ocode: Vue.ls.get('code')
        },
      })
    },
    showEva(item) {
      console.log('111111111111111', item)
      this.scheduleId = item.scheduleId
      if (item.hasComment) {
        this.$message.success('您已经提交过评价啦~')
      } else {
        if (item.status === '0') {
          this.$message.success('课次暂未开始，无法进行评价哦~')
        } else {
          this.isShowEva = true
        }
      }
      // stars().then(res => {
      //   console.log(res)
      //   this.startList = res
      // })
    },
    // evaluatRefresh() {
    //   // console.log(this.$refs.postRef)
    //   console.log(123)
    //   this.isShowEva = false
    // },
    start(start) {
      console.log(start)
      this.starts.push(start)
    },
    submit() {
      const param = {
        classesId: this.classesId,
        content: this.content,
        scheduleId: this.scheduleId,
        stars: this.starts,
      }
      if (!this.isSign && !this.isShowZhibo) {
        param.planclassesId = this.planclassesId
      }
      // console.log(this.startList)
      // console.log(this.starts)
      if (!this.content) {
        return this.$message.error('评价内容不能为空')
      }
      if (!this.starts.length) {
        return this.$message.error('评价星级不能为空')
      }
      addStart(param)
        .then((res) => {
          console.log(res)
          res && this.$message.success('感谢您的评价~')
          this.isEvaluate = false
          this.getInfo()
        })
        .catch((res) => {
          // this.isEvaluate = false
        })
    },
    changeTab(num) {
      this.tab = num
      if (num === '3') {
      }
    },
    async showResource(item) {
      this.$refs.resourceList.show(item)
    },
  },
}
</script>
<style scoped lang="less">
.ant-input {
  background: #f5f8fa;
  border-radius: 15px;
}

/deep/.ant-form-item-label {
  font-size: 16px;
  color: #181d21;
  // font-weight: bold;
}

.main-body {
  // width: 1200px;
  margin: 0 auto;
  color: #303133;
  // background: #f5f6fa;
}

.workplace_card {
  width: 100%;
  height: 272px;
  display: flex;
  align-items: center;
  // background: red;
}

.img {
  width: 180px;
  height: 137px;
  border-radius: 10px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }

  // background-image: url(~@/assets/login_back.png);
}

.text {
  width: 300px;
  height: 100%;
}

.content {
  padding: 10px;

  // padding-bottom: 26px;
  .list-item {
    // & > div {
    //   margin-bottom: 10px;
    // }
    // padding: 20px;
    color: #5e668d;
    background: #ffffff;
    // box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
  }

  .course-badge {
    color: #fff;
    border-radius: 2px;
    padding: 0 2px;
    font-size: 12px;
  }

  .nearly {
    background-color: #ff1536;
  }

  .progress {
    width: 60%;
  }

  .img-wrapper {
    width: 35px;
    height: 35px;
    background-color: red;
    margin-right: 10px;
    border-radius: 50%;
    overflow: hidden;
  }

  .icon-img {
    width: 15px;
    height: 15px;
  }
}

.list-content {
  color: #303133;

  .list-item {
    &>div {
      margin-bottom: 10px;
    }

    height: 190px;
    padding: 20px;
    // color: #5e668d;
    background: #ffffff;
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
  }

  .course-badge {
    color: #fff;
    border-radius: 2px;
    padding: 0 2px;
    font-size: 12px;
  }

  .nearly {
    background-color: #ff1536;
  }

  .progress {
    width: 60%;
  }

  .img-wrapper {
    width: 35px;
    height: 35px;
    background-color: red;
    margin-right: 10px;
    border-radius: 50%;
    overflow: hidden;
  }

  .icon-img {
    width: 15px;
    height: 15px;
  }
}

.fold-button {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  width: 30px;
  height: 20px;
  border-radius: 4px;
  background: red;
}

.fold-button:checked {
  background: green;
}

.fold-button+section {
  overflow: hidden;
}

.fold-button+section>div.fold-content {
  /* 高度仍然存在(仍然占位) */
  /* transform: translateY(0);
        transform-origin: top; */
  /* 太生硬没有过渡效果 */
  /* display: block; */
  /* 撑不开父级 */
  /* position: absolute;
        top: 0;
        left: 0; */
  /* 高度仍然存在(仍然占位) */
  /* position: relative;
        top: 0; */
  height: 200px;
  background: #def;
  border-radius: 4px;
  opacity: 1;
  overflow: hidden;
  transition: height 1s ease-out, opacity 1s ease-out;
  -moz-transition: height 1s ease-out, opacity 1s ease-out;
}

.fold-button:checked+section>div.fold-content {
  opacity: 0;
  height: 0;
  /* 高度仍然存在(仍然占位) */
  /* transform: translateY(-100%); */
  /* 太生硬没有过渡效果 */
  /* display: none; */
  /* 撑不开父级 */
  /* top: -100%; */
}

.classCatalog {

  // width: 1000px;
  // overflow-x: hidden;
  // height: 300px;
  // background: red;
  .header {
    width: 100%;
    height: 50px;
    padding: 20px;
    color: #181d21;
    background: #f5f6fa;
    // box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
    // background: blue;
  }

  .content {
    width: 100%;
    // margin-bottom: 26px;
    // height: 80px;
    background: #ffffff;
    // .content-l{
    //   width: 100px;
    //   height: 60px;
    // }
  }

  .link-name {
    background: #eef4fe;
    color: #1564ff;
    font-size: 14px;
    padding: 0 5px 0 5px;
    border-radius: 5px;
    cursor: pointer;
  }
}

.ask-content {
  .header {
    width: 80px;
  }

  .pc-img {
    width: 200px;
    height: 80px;
  }
}

.images {
  position: relative;
  display: flex;
  // justify-content: space-evenly;
  margin-top: 18px;

  img {
    width: 194px;
    height: 118px;
    margin-right: 14px;
    object-fit: contain;
  }

  .add {
    position: absolute;
    left: 624px;
    width: 194px;
    text-align: center;
    color: #fff;
    line-height: 118px;
    font-size: 24px;
    background-color: rgba(0, 0, 0, 0.76);
    border-radius: 5px;
  }
}

.empty-img {
  width: 150px;
}

.living-icon {
  width: 10px;
  height: 10px;
}

.f-els3_3 {
  width: 700px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  // text-align: center;
}

.ant-btn-round {
  width: 82px;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #fff;
  background: #4b7dfd;
  border-radius: 4px;
}

.large-btn {
  width: 100px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  border-radius: 4px;
}

/deep/ .ant-tabs-ink-bar {
  border-radius: 2px;
  // height: 0;
}

/deep/ .ant-tabs-tab {
  padding: 15px 0 4px;
  margin: 0;
  line-height: 25px;
  margin-left: 10px;
  margin-right: 42px;
}

/deep/.ant-list-item {
  margin-bottom: 0 !important;
}
</style>
